<template>
  <div v-if="!loading" class="staff-edit-photo">
    <p>{{ i18n('title') }}:</p>
    <p>1. {{ i18n('info1') }}</p>
    <div class="ml-1">
      <img src="/img/sign.jpg" alt="" />
    </div>
    <p>2. {{ i18n('info2') }}</p>
    <c-upload
      v-model="data"
      :limit="limit"
      :size="uploadSize"
      :disabled="disabled"
      @change="updatePhoto"
    />
    <p>
      Name:
      <span class="text-primary">
        <template v-if="userType === 'worker'">
          {{ info.name }}
        </template>
        <template v-if="userType === 'staff'">
          {{ info.enName }}
        </template>
      </span>
    </p>
    <p>
      {{ userType === 'staff' ? 'Staff ID:' : 'Worker ID:' }}
      <span class="text-primary">{{ info.nric }}</span>
    </p>
  </div>
</template>

<script>
import CUpload from '@/components/upload/index.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { staff } from '@/api/staff/index'
import Worker from '@/api/worker/index'
import { mapGetters } from 'vuex'

export default {
  components: {
    CUpload,
  },
  data() {
    return {
      data: undefined,
      limit: 1,
      uploadSize: 1,
      disabled: false,
      loading: true,
      info: {},
    }
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    userType() {
      if (this.userAllInfo.workerId && this.userAllInfo.workerId !== -1) {
        return 'worker'
      }
      if (this.userAllInfo.staffId && this.userAllInfo.staffId !== -1) {
        return 'staff'
      }
      return null
    },
    id() {
      // return this.userAllInfo.staffId || null
      if (this.userType === 'worker') {
        return this.userAllInfo.workerId
      }
      if (this.userType === 'staff') {
        return this.userAllInfo.staffId
      }
      return null
    },
  },
  watch: {
    id: {
      immediate: true,
      deep: true,
      handler(e) {
        if (e) {
          this.onload(e)
        }
      },
    },
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.editSign.${param}`)
    },
    async onload(id, loading = true) {
      this.loading = loading
      if (this.userType === 'staff') {
        const res = await staff.detail({ staffId: id })
        const temp = res.data.data.staff.autographAttach || {}
        this.data = temp.link ? temp : undefined
        this.info = res.data.data.staff
      }
      if (this.userType === 'worker') {
        const res = await Worker.getWorkBaseDetail({ workerID: id })
        const temp = res.data.data.infoVO.signType || {}
        this.data = temp.link ? temp : undefined
        this.info = res.data.data.infoVO
      }
      this.loading = false
    },
    updatePhotoWorker(e) {
      const params = {
        id: this.id,
        sign: e.map((o) => o.attachId).join() || -1,
      }
      Worker.updateBaseInfo(params, { key: 'sign' }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    updatePhotoStaff(e) {
      const params = {
        id: this.id,
        autograph: e.map((o) => o.attachId).join() || -1,
      }
      const key = 'autograph'
      staff.update(params, { key }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    updatePhoto(e) {
      if (this.userType === 'worker') {
        this.updatePhotoWorker(e)
      }
      if (this.userType === 'staff') {
        this.updatePhotoStaff(e)
      }
    },
  },
}
</script>
<style lang="scss">
// Core variables and mixins
@import '~@core/scss/base/bootstrap-extended/include';
// Overrides user variable
@import '~@core/scss/base/components/include';
.dark-layout {
  .ant-upload {
    border-color: $theme-dark-input-border-color;
    background-color: $theme-dark-input-bg;
  }
}
.staff-edit-photo {
  .upload-image .file-img,
  .upload-image .avatar-uploader > .ant-upload {
    width: 30rem;
    height: 30rem;
    background-color: #fff;
    i {
      font-size: 80px;
    }
    .ant-upload-text {
      font-size: 30px;
    }
  }
}
</style>
